@if (isLoggingOut() || (isLoading && !isAuthenticated) || (loaderService.isLoading && !isAuthenticated)) {
<div
  class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20"
>
  <lib-loading-indicator
    [isLoading]="isLoggingOut() || (isLoading && !isAuthenticated) || (loaderService.isLoading && !isAuthenticated)"
    [color]="'text-red-800'"
  ></lib-loading-indicator>
</div>
}
<div
  class="flex flex-col w-full h-screen"
  [ngClass]="{ 'app-application-detail-page': isApplicationDetailPage }"
>
  <div class="flex flex-1 min-h-0 overflow-hidden">
    @if (isAuthenticated && showSidebarAndHeader && (isOperationsAdmin() ||
    isAdmin())) {
    <lib-sidebar
      #sidebar
      (isExpandedChange)="sidebarExpanded.set($event)"
      theme="ignyte"
      toggleIcon="sidebarToggleIcon"
      class="transition-all duration-300 flex-shrink-0 ignyte-sidebar h-full app-sidebar"
      [displayName]="userDisplayName"
      (signOut)="signOut()"
    ></lib-sidebar>
    }
    <div
      class="flex-1 flex flex-col main-section min-w-0 max-w-full min-h-0 overflow-y-auto overflow-x-hidden"
      [ngClass]="
        isAuthenticated
          ? showSidebarAndHeader
            ? 'px-4 py-4 space-y-2 bg-gray-50'
            : 'px-0 py-0 space-y-0 bg-transparent'
          : 'px-0 py-0 space-y-0 bg-transparent'
      "
    >
      @if (isAuthenticated && showSidebarAndHeader) {
      <div class="flex items-end justify-between gap-2">
        <div class="flex items-end gap-2">
          @if (isOperationsAdmin() || isAdmin()) {
          <div class="app-sidebar-toggle-btn">
            <lib-button
              [customClass]="'flex items-center justify-center h-8 w-8  p-0 '"
              (buttonClick)="toggleSidebar()"
              [ariaLabel]="sidebarAriaLabel()"
            >
              <lib-icon
                icon="sidebarToggleIcon"
                [category]="AssetsCategory.Sidebar"
                class="w-4 h-4"
              ></lib-icon>
            </lib-button>
          </div>
          }
          @if (showBreadcrumbs) {
          <lib-breadcrumbs></lib-breadcrumbs>
          }
        </div>

        @if (!isOperationsAdmin() && !isAdmin()) {
        <div class="app-logout-btn">
          <lib-button
            (buttonClick)="signOut()"
            [disabled]="isLoggingOut()"
            [customClass]="'flex mb-1.5 items-center gap-1.5 px-0 py-0 hover:opacity-80 transition-opacity bg-transparent border-none shadow-none cursor-pointer' + (isLoggingOut() ? ' opacity-60 cursor-not-allowed' : '')"
          >
            <div class="filter-ignyte-theme">
              <lib-icon
                icon="LogoutIcon"
                [category]="AssetsCategory.Sidebar"
                iconClass="w-3.5 h-3.5"
              ></lib-icon>
            </div>
            <span class="text-sm font-medium text-ignyte-theme">Log out</span>
          </lib-button>
        </div>
        }
      </div>
      }

      <lib-toast-container></lib-toast-container>

      <div
        class="flex-1 flex flex-col min-w-0 min-h-0 max-w-full"
        [ngClass]="isAuthenticated && showSidebarAndHeader ? 'px-4' : 'px-0'"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <footer class="flex-shrink-0 px-4 py-2"
    [ngClass]="showErrorFooter ? 'bg-ignyte-page' : (isAuthenticated && showSidebarAndHeader ? 'bg-gray-50' : '')">
    <div class="flex items-center w-full text-gray-400 text-xs md:text-lg"
      [ngClass]="showErrorFooter ? 'justify-center' : 'justify-between'">
      @if (!showErrorFooter) {
      <span>© 2026  Yrefy LLC</span>
      }
      @if (showErrorFooter) {
      <span>&#64;2026 Ignyte. All rights reserved</span>
      }

      @if (!showErrorFooter) {
      <span>
        <span class="hidden md:inline">Questions? Contact us at </span>
        <img src="assets/shared/images/icons/default/mail.svg" class="text-red-500 fill-red-500 h-4 w-4 mr-1 inline md:hidden"/>
        <a class="text-red-500 underline" href="mailto:ignytesupport&#64;yrefy.com"> ignytesupport&#64;yrefy.com </a>
      </span>
      }
    </div>
  </footer>
</div>
